module.exports = __webpack_public_path__ + "media/images/icon/icons8-Vertical Settings Mixer-3a34e9bf09941f42cf46341d57b0459f.png";